document.addEventListener('livewire:navigated', function () {
    initializeSearchForm();

    // Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
    //     succeed(({ snapshot, effect }) => {
    //         queueMicrotask(() => {
    //             initializeSearchForm();
    //         });
    //     });
    //
    //     fail(() => {
    //         // console.error('Failed to process Livewire message.');
    //     });
    // });

    function initializeSearchForm() {
        var componentContainerSelector = '.header-search-form';

        $(document).off('click.searchForm').on('click.searchForm', function (e) {
            if($(e.target).closest(componentContainerSelector).length === 0) {
                var $resultsBlock = $(componentContainerSelector + ' .search__results');
                $resultsBlock.addClass('d-none');
                $(componentContainerSelector).removeClass('show');
            }
        });

        $(componentContainerSelector).off('click.searchForm').on('click.searchForm', function (e) {
            $(this).find('.search__results').removeClass('d-none');
            $(componentContainerSelector).addClass('show');
        });
    }
});
